import type { DetrixNetworkEntry } from '../types';

export function generateCurl(entry: DetrixNetworkEntry): string {
  const { request } = entry;
  let curl = `curl -X ${request.method} '${request.url}'`;

  Object.entries(request.headers).forEach(([key, value]) => {
    curl += ` \\\n  -H '${key}: ${value}'`;
  });

  if (request.body && request.body.length < 10_000) {
    const escapedBody = request.body.replace(/'/g, `'\\''`);
    curl += ` \\\n  --data '${escapedBody}'`;
  }

  return curl;
}
